// directives/show.js
export const show = {
    selector: '[data-show]',
    reactive: true,
    run(el, data, root) { 
        const expression = el.getAttribute('data-show');

        const evaluate = () => {
            try {
                // Evaluate using a `with` block to allow access to getters like isLarge
                const fn = new Function('data', `with (data) { return (${expression}); }`);
                return fn(data);
            } catch (e) {
                console.warn(`Invalid expression in data-show: ${expression}`, e);
                return false;
            }
        };


        const update = () => {
            const result = evaluate();
            el.style.display = result ? '' : 'none';
        };

        update();

        // Re-run update on any change
        if (!root.__showWatchers) root.__showWatchers = [];
        root.__showWatchers.push(update);
    }
};